import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed the video volume',
  name: 'changed_video_volume',
  params: [
    {
      description: 'The ID of the clip',
      name: 'id',
      required: true,
      type: 'string',
    },
    {
      description: 'The new volume level',
      name: 'volume',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
